var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiSparkStarlightStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.43 -1.43 40 40",
    id: "Ai-Spark-Starlight--Streamline-Flex",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Ai Spark Starlight Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ai-spark-starlight--ai-spark-starlight-generating-creation-automate"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 497",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1.9896428571428573 1.9896428571428573 4.798594114285715 4.798594114285715",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 498",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1.9896428571428573 35.150357142857146 4.798594114285715 -4.798488",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 499",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m35.150357142857146 1.9896428571428573 -4.798488 4.798594114285715",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 500",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m35.150357142857146 35.150357142857146 -4.798488 -4.798488",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2142",
    fill: "#ffffff",
    d: "M14.05045992857143 14.08221462857143C16.866414728571428 11.266259828571428 17.3960046 5.968928571428572 18.570106114285718 5.968928571428572c1.1740749857142858 0 1.7036648571428572 5.297331257142857 4.519646185714286 8.113286057142858C25.9057071 16.89816942857143 31.16815328571429 17.19643015714286 31.16815328571429 18.5670288c0 1.3705721142857143 -5.262446185714286 1.668832842857143 -8.078400985714287 4.484787642857143 -2.815981328571429 2.8159548 -3.3455712 8.1134187 -4.519646185714286 8.1134187 -1.1741015142857143 0 -1.7036913857142857 -5.2974639 -4.519646185714286 -8.1134187 -2.815981328571429 -2.8159548 -8.078294871428572 -3.1142155285714286 -8.078294871428572 -4.484787642857143 0 -1.370598642857143 5.262313542857143 -1.6688593714285715 8.078294871428572 -4.484814171428572",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2141",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.05045992857143 14.08221462857143C16.866414728571428 11.266259828571428 17.3960046 5.968928571428572 18.570106114285718 5.968928571428572c1.1740749857142858 0 1.7036648571428572 5.297331257142857 4.519646185714286 8.113286057142858C25.9057071 16.89816942857143 31.16815328571429 17.19643015714286 31.16815328571429 18.5670288c0 1.3705721142857143 -5.262446185714286 1.668832842857143 -8.078400985714287 4.484787642857143 -2.815981328571429 2.8159548 -3.3455712 8.1134187 -4.519646185714286 8.1134187 -1.1741015142857143 0 -1.7036913857142857 -5.2974639 -4.519646185714286 -8.1134187 -2.815981328571429 -2.8159548 -8.078294871428572 -3.1142155285714286 -8.078294871428572 -4.484787642857143 0 -1.370598642857143 5.262313542857143 -1.6688593714285715 8.078294871428572 -4.484814171428572",
    strokeWidth: 2.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSparkStarlightStreamlineFlex);
export default __webpack_public_path__ + "static/media/Ai-Spark-Starlight--Streamline-Flex.c7a8c91bd0405c65b5f3fffd47bf64ec.svg";
export { ForwardRef as ReactComponent };